module.exports = __webpack_public_path__ + "img/instant-booking-logo.0bacf86f.svg";